module.exports = __webpack_public_path__ + "static/media/sun-glasses-5.38937a85.jpg";